var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activateSpinner
        ? _c("spinner")
        : _c("div", [
            _vm.formType !== "edit"
              ? _c("div", [
                  _c(
                    "div",
                    [
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.security.pem"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "d-flex form-group" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      "input-value": _vm.currentCA.name,
                                      isMandatory: "",
                                      inputLabel: _vm.$t(
                                        "common.security.name"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.name"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mx-auto mb-4" }),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.security.certificat"),
                            isTitleUpperCase: false,
                          },
                        },
                        _vm._l(
                          _vm.currentCA.Certificates,
                          function (certificat) {
                            return _c(
                              "b-row",
                              {
                                key: certificat.id,
                                staticClass:
                                  "d-flex align-items-center form-group",
                              },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group mb-5",
                                    attrs: { sm: "4" },
                                  },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputValue: certificat.name,
                                        inputLabel: _vm.$t(
                                          "common.security.name"
                                        ),
                                        placeholderValue: _vm.$t(
                                          "common.security.name"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group mb-5",
                                    attrs: { sm: "4" },
                                  },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputValue: certificat.startDate,
                                        inputLabel: _vm.$t(
                                          "common.security.startDate"
                                        ),
                                        placeholderValue: _vm.$t(
                                          "common.security.startDate"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group mb-5",
                                    attrs: { sm: "4" },
                                  },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputValue: certificat.endDate,
                                        inputLabel: _vm.$t(
                                          "common.security.endDate"
                                        ),
                                        placeholderValue: _vm.$t(
                                          "common.security.endDate"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group mb-5",
                                    attrs: { sm: "4" },
                                  },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputValue: certificat.deliveredBy,
                                        inputLabel: _vm.$t(
                                          "common.security.deliveredBy"
                                        ),
                                        placeholderValue: _vm.$t(
                                          "common.security.deliveredBy"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group mb-5",
                                    attrs: { sm: "4" },
                                  },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputValue: certificat.deliveredTo,
                                        inputLabel: _vm.$t(
                                          "common.security.deliveredTo"
                                        ),
                                        placeholderValue: _vm.$t(
                                          "common.security.deliveredTo"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-col", {
                                  staticClass: "form-group mb-5",
                                  attrs: { sm: "4" },
                                }),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _c(
                  "div",
                  [
                    _c("ca-form-pem", {
                      ref: "caFormPem",
                      attrs: {
                        store: 0,
                        certificate: _vm.currentCA.Certificates,
                        id: _vm.currentCA.id,
                        name: _vm.currentCA.name,
                      },
                    }),
                  ],
                  1
                ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }